import { TinyColor } from '@ctrl/tinycolor';
import { ColorInput } from '@ctrl/tinycolor/dist';

const lighter = (color: ColorInput): string => {
  return new TinyColor(color).lighten(30).toHexString();
};

const light = (color: ColorInput): string => {
  return new TinyColor(color).lighten(15).toHexString();
};

const dark = (color: ColorInput): string => {
  return new TinyColor(color).darken(15).toHexString();
};

const darker = (color: ColorInput): string => {
  return new TinyColor(color).darken(30).toHexString();
};

const color = {
  lighter,
  light,
  dark,
  darker,
};
export default color;
